import Joi from 'joi-browser';

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined);

export const requiredInput = (value) => (value ? undefined : 'This field is required');

export const stringInput = (value) =>
  Joi.string().max(200).validate(value).error ? 'The maximum length is 200 characters' : undefined;

export const postalCode = (value) =>
  Joi.string().max(5).min(5).validate(value).error || !/^-?\d+$/.test(value) ? 'The value must be 6 numbers' : undefined;

export const emailInput = (value) =>
  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Please enter a valid email address' : undefined;

export const passwordInput = (value) => {
  const stringCount = value.length;
  const lowercaseCount = (value.match(/[a-z]/g) || []).length;
  const upperCaseCount = (value.match(/[A-Z]/g) || []).length;
  const numericCount = (value.match(/[0-9]/g) || []).length;

  if (lowercaseCount >= 1 && upperCaseCount >= 1 && numericCount >= 1 && stringCount >= 8) {
    return undefined;
  }

  return 'The password must be at least 8 characters long and contain upper and lower case letters and numbers';
};

export const bicInput = (value) => {
  if (!value) return undefined;
  if (value.length !== 11) {
    return 'BIC must be exactly 11 characters';
  }
  return undefined;
};
